import Page from './page';
import Shop from './shop';
import Product from './product';
import Customer from './customer';
import Order from './order';

export default {
  namespaced: true,

  modules: {
    page: Page,
    shop: Shop,
    customer: Customer,
    product: Product,
    order: Order,
  },

  actions: {
    async init({dispatch, getters}) {
      // eslint-disable-next-line
      console.log('store shopify init');

      return new Promise(async resolve => {
        await dispatch('page/init');
        await dispatch('shop/init');
        await dispatch('customer/init');
        await dispatch('product/init').catch((e) => { console.error('product load failed', e); });
        await dispatch('order/init');

        resolve();
      });
    },
  },
};
